'use strict';

var React              = require('react'),
    moment             = require('moment');

var ScheduleRange = React.createClass({
  propTypes: {
    firebaseUrl: React.PropTypes.string.isRequired,
    startAt: React.PropTypes.string.isRequired,
    endAt: React.PropTypes.string.isRequired
  },

  componentDidMount: function() {
    var firebaseRef = new Firebase(this.props.firebaseUrl);
    firebaseRef
      .orderByChild("start_time")
      .startAt(this.props.startAt)
      .endAt(this.props.endAt)
      .once("value", function(snapshot) {
        var events = [];

        // We use snapshot itteration to ensure our desired order to preserved
        snapshot.forEach(function(eventSnapshot) {
          var event = eventSnapshot.val();
          event.key = eventSnapshot.key();

          events.push(event);
        });

        this.setState({
          events: events
        });
      }.bind(this));
    this.setState({
      firebaseRef: firebaseRef,
    });
  },

  componentWillUnmount: function() {
    this.state.firebaseRef.off();
  },

  getInitialState: function() {
    return {
      events: [
        {
          title: "Loading…"
        }
      ]
    };
  },

  _getTime: function(str) {
    if(typeof(str) === "undefined") {
      return "";
    }

    var date = moment.parseZone(str);
    return date.format('h:mm');
  },

  _getTimeSuffix: function(str) {
    if(typeof(str) === "undefined") {
      return "";
    }

    var date = moment.parseZone(str);
    return date.format(' A');
  },

  _getName: function(name) {
    if(name) {
      return (
        <small>{name}</small>
      );
    }
  },

  render: function() {
    var _this = this;

    return (
      <table className="schedule">
        <thead>
          <th className="schedule-timeHeader">Time</th>
          <th className="schedule-eventHeader">Event</th>
          <th className="schedule-locationHeader">Location</th>
        </thead>
        <tbody>
          {this.state.events.map(function(event) {
            var endTimeDiv = (
              <div>
                  <span className="schedule-timeDigit">
                    {_this._getTime(event.end_time)}
                  </span>
                  {_this._getTimeSuffix(event.end_time)}
              </div>
            );

            return (
              <tr key={event.key}>
                <td>
                  <span className="schedule-timeDigit">
                    {_this._getTime(event.start_time)}
                  </span>
                  {_this._getTimeSuffix(event.start_time)}
                  {event.end_time !== undefined ? "-" : null}
                  {event.end_time !== undefined ? endTimeDiv : null}
                </td>
                <td>
                  {event.title}
                  {_this._getName(event.name)}
                </td>
                <td>{event.location}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
});

module.exports = ScheduleRange;



/** WEBPACK FOOTER **
 ** ./js/screens/main-2015/schedule-range.jsx
 **/